const { date } = require('@virtual-peaker/vp-common').vpFilters.datetime;
const { number } = require('@virtual-peaker/vp-common').vpFilters.arithmetic;

export default {
  date,
  number,
};